import React, { useState } from 'react';


function PrivacyPolicyBody(props) {

    const [side, setSide] = useState([
        {id:1,title:'Introduction'},
        {id:2,title:'Scope of the Privacy Policy'},
        {id:3,title:'Data Collection'},
        {id:4,title:'Purpose of Data Collection'},
        {id:5,title:'Data Sharing and Disclosure'},
        {id:6,title:'Data Protection and Security'},
        {id:7,title:'User Rights'},
        {id:8,title:'Data Retention'},
        {id:9,title:'Cookies and Tracking Technologies'},
        {id:10,title:'Protection of Children’s Data'},
        {id:11,title:'Compliance with African Data Protection Laws'},
        {id:12,title:'Changes to the Privacy Policy'},
        {id:13,title:'Contact Info'},
        {id:14,title:'Aknowledgement'},
    ])

    const [active, setActive] = useState(1)

    const changeActive = (id) => {
        setActive(id)
        document.getElementById(id).scrollIntoView({behavior:'smooth'})
        
    }

    return (
        <div className='flex flex-col px-5 lg:px-10 mt-5 lg:mt-10 mb-10 lg:mb-20'>
            <div className='text-center text-[30px] lg:text-[48px] font-[500]'>Privacy Policy</div>
            <div className='grid grid-cols-8 gap-x-10 mt-5 lg:mt-10'>
            <div className='hidden h-[600px] lg:flex col-span-2 rounded-[8px] py-5 px-3 flex flex-col bg-[#FBFBFB] border-[1px] border-[#E0E0E0] space-y-3'>
                {side.map(({id,title}) => {
                    return (
                        <span onClick={() => changeActive(id)} key={id} className={`cursor-pointer text-start font-[400] text-[16px] ${active == id ? 'text-[#008B39]' : 'text-[#737373]'}`}>{title}</span>
                    )
                })}
            </div>
            <div className='col-span-8 lg:col-span-6 flex flex-col text-[#424242] text-[16px] text-start space-y-2'>
                <div className='flex flex-col'>
                    <span>Privacy Policy for Yebokenny App</span>
                    <span>Effective Date: 1st September, 2023</span>
                </div>
                <div id='1' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>1. Introduction</span>
                    <span>Yebokenny App (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) is committed to protecting your privacy and ensuring
                        the security of your personal information. This Privacy Policy outlines how we collect, use,
                        store, and protect personal data of all users and subscribers in Africa. By using Yebokenny
                        App, you agree to the terms of this Privacy Policy. If you do not agree, please discontinue
                        using the App.
                    </span>
                </div>
                <div id='2' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>2. Scope of the Privacy Policy</span>
                    <span className='flex flex-col'>
                        <span>1.1. This Privacy Policy applies to all users and subscribers of Yebokenny App across Africa.</span>
                        <span>1.2. It governs personal data collected through the Yebokenny App, related services, and
                        interactions with our customer support.
                        </span>
                    </span>
                </div>
                <div id='3' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>3. Data Collection</span>
                    <span className='font-[400] text-[#0E0E0E]'>3.1 Personal Information We Collect</span>
                    <span className='flex flex-col pl-2'>
                        <span>We may collect the following personal information:</span>
                        <span>A. Identity Data: Name, date of birth, gender, and nationality.</span>
                        <span>B. Contact Data: Email address, phone number, and physical address.</span>
                        <span>C. Account Data: Username, password, and account activity.</span>
                        <span>D. Payment Data: Billing information, credit/debit card details, and mobile money
                        transaction details.</span>
                        <span>E. Device Data: Device type, operating system, IP address, browser type, and usage
                        statistics.</span>
                        <span>F. Location Data: Geolocation information, where permission is granted.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>3.2 How We Collect Information</span>
                    <span className='flex flex-col pl-2'>
                        <span>We collect personal information through:</span>
                        <span>A. Registration forms when creating an account.</span>
                        <span>B. Your interactions and activity on the App.</span>
                        <span>C. Payment and subscription processes.</span>
                        <span>D. Customer service inquiries and surveys.</span>
                        <span>E. Device permissions granted by users (e.g., access to location or camera).</span>
                    </span>
                </div>
                <div id='4' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>4. Purpose of Data Collection</span>
                    <span className='flex flex-col'>
                        <span>We collect and process your personal information for the following purposes:</span>
                        <span>A. Service Delivery: To provide, personalize, and improve our services.</span>
                        <span>B. Payments and Billing: To process payments and issue invoices.</span>
                        <span>C. Customer Support: To respond to inquiries and resolve issues.</span>
                        <span>D. Security: To detect and prevent fraud, unauthorized access, and other security threats.</span>
                        <span>E. Legal Compliance: To comply with applicable laws and regulations.</span>
                        <span>F. Marketing: To send promotions, updates, and newsletters (with your consent).</span>
                    </span>
                </div>
                <div id='5' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>5. Data Sharing and Disclosure</span>
                    <span className='font-[400] text-[#0E0E0E]'>5.1 Sharing with Third Parties</span>
                    <span className='flex flex-col pl-2'>
                        <span>We may share your personal data with:</span>
                        <span>A. Service Providers: Payment processors, cloud storage providers, and customer
                        support tools, solely for service-related purposes.</span>
                        <span>B. Law Enforcement: Where required by law or to protect our rights, property, or
                        safety.</span>
                        <span>C. Business Partners: For promotional campaigns or collaborative services (with
                            explicit consent).</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>5.2 Cross-Border Data Transfers</span>
                    <span className='flex flex-col pl-2'>
                        <span>Data may be transferred to servers or third parties located outside your country. We ensure
                            such transfers comply with data protection laws through appropriate safeguards, such as
                            contractual agreements.
                        </span>
                    </span>
                </div>
                <div id='6' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>6. Data Protection and Security</span>
                    <span className='flex flex-col'>
                        <span>A. We implement industry-standard security measures, including encryption, firewalls, and
                        secure data storage, to protect your personal information.</span>
                        <span>B. Access to personal data is restricted to authorized personnel only.</span>
                        <span>C. While we strive to protect your data, no method of transmission or storage is 100%
                        secure, and we cannot guarantee absolute security.</span>
                    </span>
                </div>
                <div id='7' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>7. User Rights</span>
                    <span className='font-[400] text-[#0E0E0E]'>You have the following rights concerning your personal information:</span>
                    <span className='font-[400] text-[#0E0E0E]'>7.1 Access</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can request access to the personal data we hold about you.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>7.2 Correction</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can update or correct inaccuracies in your personal data.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>7.3 Deletion</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can request the deletion of your personal data, subject to legal and operational
                        requirements.
                        </span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>7.4 Restriction</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can request that we limit the processing of your personal data.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>7.5 Data Portability</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can request a copy of your personal data in a structured, machine-readable format.</span>
                    </span>
                    <span className='font-[400] text-[#0E0E0E]'>7.6 Withdrawal of Consent</span>
                    <span className='flex flex-col pl-2'>
                        <span>You can withdraw your consent for marketing communications or other optional data uses at
                        any time.</span>
                        <span>To exercise your rights, contact us at +27 (0) 33 492 0174</span>
                    </span>
                </div>
                <div id='8' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>8. Data Retention</span>
                    <span className='flex flex-col'>
                        <span>8.1 We retain personal information only as long as necessary for the purposes outlined in this
                        Privacy Policy or as required by law.</span>
                    </span>
                    <span className='flex flex-col'>
                        <span>8.2 When data is no longer needed, it is securely deleted or anonymized.</span>
                    </span>
                </div>
                <div id='9' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>9. Cookies and Tracking Technologies</span>
                    <span>9.1. Yebokenny App uses cookies and similar technologies to enhance user experience,
                    analyze usage patterns, and deliver targeted content.
                    </span>
                    <span>9.2. You can manage cookie preferences through your device settings.</span>
                </div>
                <div id='10' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>10. Protection of Children’s Data</span>
                    <span>10.1. Yebokenny App does not knowingly collect personal data from children under the age of
                    18 without parental consent.
                    </span>
                    <span>10.2. If we discover unauthorized data collection from a minor, we will promptly delete it..</span>
                </div>
                <div id='11' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>11. Compliance with African Data Protection Laws</span>
                    <span className='flex flex-col pl-2'>
                        <span>Yebokenny App complies with applicable data protection laws, including:</span>
                        <span>A. <span className='font-[500]'>General Data Protection Regulation (GDPR)</span> as applicable in Africa.</span>
                        <span>B. <span className='font-[500]'>Kenya’s Data Protection Act (2019).</span></span>
                        <span>C. <span className='font-[500]'>Nigeria’s Data Protection Regulation (NDPR).</span></span>
                        <span>D. <span className='font-[500]'>South Africa’s Protection of Personal Information Act (POPIA).</span></span>
                        <span>E. Other relevant data protection laws in African countries.</span>
                    </span>
                </div>
                <div id='12' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>12. Changes to the Privacy Policy</span>
                    <span>12.1. We may update this Privacy Policy periodically.</span>
                    <span>12.2. Changes will be communicated through the App or email, and continued use constitutes
                    acceptance of the revised policy.</span>
                </div>
                <div id='13' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>13. Contact Information</span>
                    <span className='flex flex-col'>
                        <span>If you have any questions, concerns, or complaints about this Privacy Policy or our data
                        practices, contact us:</span>
                        <span><span className='font-[500]'>Email: </span>Business@yebokenny.com</span>
                        <span><span className='font-[500]'>Phone: </span>+27 (0) 33 492 0174 / (0) 10 497 4633</span>
                        <span><span className='font-[500]'>Address: </span> 26 Kingsford Avenue, Kingston Park, Pietermaritzburg 3201, Kwazulu
                        Natal, South Africa.</span>
                    </span>
                </div>
                <div id='14' className='flex flex-col space-y-1'>
                    <span className='font-[500] text-[#0E0E0E]'>Acknowledgment</span>
                    <span className='flex flex-col'>
                        <span>By using Yebokenny App, you acknowledge that you have read, understood, and agreed to
                        this Privacy Policy.</span>
                    </span>
                </div>
            </div>
        </div>
        </div>

    );
}

export default PrivacyPolicyBody;